import { useTranslate } from '@tolgee/react';
import { useMount } from 'ahooks';
import { ModalProps, Table, message } from 'antd';
import StatusSwitch from 'components/StatusSwitch';
import { JustRightHeightModal } from 'components/styled/scoped';
import useCrud from 'hooks/useCrud';
import { getPublicAccountList, updatePublicAccount } from 'services/api/phrase';

function PublicConfigModal({ onUpdated, ...otherProps }: ModalProps & { onUpdated?: () => void }) {
  const { t } = useTranslate();

  const { loading, list, setList, fetchList } = useCrud({
    readList: getPublicAccountList,
  });

  useMount(fetchList);

  return (
    <JustRightHeightModal
      width={435}
      title={t('公开个人快捷回复设置')}
      footer={false}
      {...otherProps}
    >
      <Table
        size="small"
        loading={loading}
        dataSource={list}
        rowKey="userId"
        columns={[
          {
            key: 'name',
            dataIndex: 'name',
            title: t('field.name'),
          },
          {
            key: 'enable',
            dataIndex: 'enable',
            title: t('是否公开'),
            render: (enable: boolean, record) => (
              <StatusSwitch
                checked={enable}
                onChange={(enable) =>
                  updatePublicAccount({
                    accountId: record.userId,
                    enable,
                  })
                    .then(() => {
                      setList((list) =>
                        list?.map((item) =>
                          item.userId === record.userId
                            ? {
                                ...item,
                                enable,
                              }
                            : item,
                        ),
                      );
                      onUpdated?.();
                    })
                    .catch(() => {
                      message.error(t('phrase.保存失败，请稍后再试'));
                    })
                }
              />
            ),
          },
        ]}
      />
    </JustRightHeightModal>
  );
}

export default PublicConfigModal;
